import Image from 'next/image';
import PropTypes from 'prop-types';
import { useState } from 'react';
import ReactModal from 'react-modal';
import { usePcConfigurator } from 'utils/PcConfiguratorContext';
import classnames from 'classnames';
import styles from './styles';
import PcModelModalHelp from '../PcModelModalHelp';
import PcModelNoticeMessage from '../PcModelNoticeMessage';

const PcModelNoticeModal = ({ currentOptions, variant }) => {
	const noticeOptions = currentOptions.filter(currentOption => currentOption.group_type == "motherboard" )
	const { pcConfigDoc } = usePcConfigurator();
	const [isOpen, setIsOpen] = useState(false);
	const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);
	const [isHovered, setIsHovered] = useState(false);
	const [isHoveredIcon, setIsHoveredIcon] = useState(false);

	const handleMouseEnter = () => {
	  setIsHoveredIcon(true);
	};
  
	const handleMouseLeave = () => {
	  setIsHoveredIcon(false);
	};

	const handleOpen = () => {
		setIsOpen(true);
		setIsHelpModalOpen(false);
	};

	const handleClose = () => {
		setIsOpen(false);
		setIsHelpModalOpen(false);
	};

	const handleHelpModalOpen = () => {
		setIsOpen(false);
		setIsHelpModalOpen(true);
	};

  if (!noticeOptions?.length) return null;

	const needHelpTitle = pcConfigDoc?.data?.need_help_title;

	return (
		<>
			{variant === 'icon' ? (
				<div className="icon-variant">
					<button type="button" onClick={handleOpen}>
						<Image
							draggable={false}
							src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/icon-exclamation-blue.svg?v=1713944876"
							alt="Error"
							width={24}
							height={24}
						/>
					</button>
				</div>
			) : (
				<div className={classnames('notice', { 'notice-hover': isHovered })}>
					<div className="icon">
						<Image
							draggable={false}
							src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/icon-exclamation-blue.svg?v=1713944876"
							alt="Error"
							width={16}
							height={16}
						/>
					</div>
					<div>
						<span>
						{`(${noticeOptions?.length})`} item/s has a notice.{' '}
						</span>{' '}
						<a
							className="view-issues"
							href="#"
							onClick={handleOpen}
							onMouseEnter={() => {
								setIsHovered(true);
							}}
							onMouseLeave={() => {
								setIsHovered(false);
							}}
						>
							View
						</a>
					</div>
				</div>
			)}

			<ReactModal
				isOpen={isOpen}
				onRequestClose={handleClose}
				className="modal-content"
				overlayClassName="modal-overlay"
				shouldCloseOnOverlayClick
				shouldCloseOnEsc
				preventScroll
				style={{
					overlay: {
						background: 'rgba(255, 255, 255, 0.25)',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						position: 'fixed',
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						zIndex: 100,
					},
					content: {
						margin: '10px',
						borderRadius: '2px',
						minWidth: '50vw',
						overflow: 'hidden',
					},
				}}
			>
				<div className="modal-wrapper">
					<div className="modal-header">
						<div className="modal-header-title">PLEASE NOTE</div>

						<div 
							className="modal-header-icon" 
							onClick={handleClose}
							onMouseEnter={handleMouseEnter}      
							onMouseLeave={handleMouseLeave}
						>
							<Image 
								src={isHoveredIcon ? 
									"https://cdn.shopify.com/s/files/1/0522/3320/7988/files/icon-close-hover.png?v=1713886520" 
									: "https://cdn.shopify.com/s/files/1/0522/3320/7988/files/icon-close.png?v=1714038756"}
								width={20}
								height={20}
							/>
						</div>
					</div>

					<div className="modal-body">
						<div className="body-message">
							The selected Motherboard does not support USB Type C headers, but
							is still compatible with your Chassis. You can continue to
							checkout, but your Chassis will not have a functional USB type C
							port. If you wish for a functional USB Type C port, please change
							the following component/s to another that supports USB Type C
							Headers.
						</div>
						<div className="notices">
              {noticeOptions.map((option) => (
                <div className="notice" key={option.id}>
                  <div className="icon">
                    <Image draggable={false} 
                      src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/icon-exclamation-blue.svg?v=1713944876"
                      alt="Error"
                      width={16}
                      height={16}
                    />
                  </div>

                  <PcModelNoticeMessage
                    option={option}
                    closeModal={handleClose}
                  />
                </div>
              ))}
						</div>
						<div className="further-message">
							We apologise for any inconvenience caused. Please feel free to
							reach out if you have any questions.
						</div>
					</div>

					<div className="modal-footer">
						<div className="need-help" onClick={handleHelpModalOpen}>
							{needHelpTitle}
						</div>
					</div>
				</div>
			</ReactModal>

			<PcModelModalHelp
				title={needHelpTitle}
				isOpen={isHelpModalOpen}
				onClose={() => setIsHelpModalOpen(false)}
				pcConfigDoc={pcConfigDoc}
			/>
			<style jsx>{styles}</style>
		</>
	);
};

PcModelNoticeModal.propTypes = {
	currentOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
	variant: PropTypes.oneOf(['toast', 'icon']),
};

PcModelNoticeModal.defaultProps = {
	variant: 'toast',
};

export default PcModelNoticeModal;
